'use strict';

module.exports = {
  ERROR: 'error',
  INFO: 'info',
  WARN: 'warn',
  DEBUG: 'debug'
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/constant/level.js
// module id = 244
// module chunks = 0